import { MessageBridge } from './messageBridge';
import ENV from '../env.json';
import { upload } from 'scripts/api';
import { fileValidation } from 'scripts/validation';
import { SLPFileType } from 'utilities/slp/file/file.index';
import { API, Base64Files } from 'data';
import {
    Question,
    QuestionTypes,
    Response,
    FileAttachment,
    QuestionValidationTypes,
    FileAttachmentTypeEnum,
} from 'interface';
import { delDBFileMime, getDBFileMime, setDBFileMime } from './db';
interface StreamingData {
    name: string;
    base64: string;
}

function sendFile(file: File) {
    return new Promise((resolve) => {
        const chunkSize = 512 * 1024;
        const chunks = Math.ceil(file.size / chunkSize);
        let chunk = 0;
        MessageBridge.request('SAVE_FILE_IN_STORAGE', file.name).then((res: boolean) => {
            setDBFileMime(file.name, file.type);
            if (res) split();
        });
        function split() {
            if (chunk === chunks) {
                MessageBridge.request('CLOSE_FILE_STORAGE', file.name).then((res: boolean) => {
                    if (res) resolve(true);
                });
                return;
            }
            const offset = chunk * chunkSize;
            const blob = file.slice(offset, chunk !== chunks ? offset + chunkSize : file.size, file.type);
            const fileReader = new FileReader();
            fileReader.readAsDataURL(blob);
            chunk = chunk + 1;
            fileReader.onload = () => {
                if (fileReader.result) {
                    const data: StreamingData = {
                        base64: fileReader.result.toString().replace(/^data:.*;base64,/, ''),
                        name: file.name,
                    };
                    MessageBridge.request('STREAM_FILE_STORAGE', data).then((res: boolean) => {
                        if (res) split();
                    });
                }
            };
        }
    });
}

function retrieveFile(name: string) {
    return new Promise<File | undefined>((resolve) => {
        getDBFileMime(name).then((mime) => {
            let blobConfig: BlobPropertyBag | undefined = undefined;
            if (mime) blobConfig = { type: mime };
            let result = new Blob([], blobConfig);
            MessageBridge.request('GET_FILE_FROM_STORAGE', name).then((result: boolean) => {
                if (!result) resolve(undefined);
            });
            MessageBridge.subscribe('RETRIEVE_FILE_STORAGE', (value: StreamingData) => {
                if (value.name === name) {
                    result = new Blob([result, b64toBlob(value.base64, blobConfig)], blobConfig);
                }
            });
            MessageBridge.subscribe('RETRIEVE_FILE_ENDED', (value: string) => {
                if (value === name) {
                    resolve(new File([result], name));
                }
            });
        });
    });
}

const b64toBlob = (b64Data: string, blobConfig?: BlobPropertyBag) => {
    const byteCharacters = atob(b64Data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], blobConfig);
    return blob;
};

// render File data
const RenderFile: (file: File) => Promise<string> = (file: File) => {
    return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = (e) => {
            if (typeof e.target?.result === 'string') resolve(e.target?.result);
        };
        reader.readAsDataURL(file);
    });
};

const StoreFile = (file: File) => {
    const id = new Date().getTime().toString() + '_' + file.name;
    if (ENV.mode === 'production') {
        const newFile = new File([file], id, { type: file.type });
        sendFile(newFile);
    }
    return id;
};

const GetFile: (id: string) => Promise<File | undefined> = (id) => {
    return new Promise<File | undefined>((resolve) => {
        if (ENV.mode !== 'production') {
            let file: File | undefined = undefined;
            const extension = id.split('.')[1];
            if (extension && ['png', 'jpg', 'jpeg', 'gif'].includes(extension))
                file = dataURLtoFile(Base64Files.image, id);
            else if (['mp3', 'mp4'].includes(extension)) file = dataURLtoFile(Base64Files.voice, id);
            else file = dataURLtoFile(Base64Files.file, id);
            resolve(file);
        } else {
            retrieveFile(id).then((value) => {
                resolve(value);
            });
        }
    });
};

function deleteFile(name: string): Promise<boolean> {
    console.log('delete calleeeeeeeeeeeeeeeeeeeeeed');
    return new Promise<boolean>((resolve) => {
        if (ENV.mode === 'production') {
            MessageBridge.request('REMOVE_FILE_FROM_STORAGE', name).then(() => {
                delDBFileMime(name).then(() => {
                    resolve(true);
                });
            });
        } else {
            resolve(true);
        }
    });
}

function dataURLtoFile(dataurl: string, name: string) {
    const arr = dataurl.split(',');
    const mime = arr[0].match(/:(.*?);/)?.[1],
        bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) u8arr[n] = bstr.charCodeAt(n);
    return new File([u8arr], `${name}`, { type: mime });
}

// upload unsend image and files
const UploadFile: (
    question: Question,
    token: string,
    ws?: number | string,
    fileName?: string,
) => Promise<FileAttachment[] | undefined> = (
    question, // for detect question input type
    token,
    ws, // workspace id for upload file
    fileName, // id file in db
) => {
    return new Promise((resolve) => {
        const fileNames = fileName?.split(', ').filter((i) => fileValidation(i));
        if (fileNames?.length) {
            const promiseFile: Promise<File | undefined>[] = [];
            const promiseUpload: Promise<Response<FileAttachment | null>>[] = [];
            fileNames.map((item) => {
                if (item && fileValidation(item) && ws) promiseFile.push(FileManager.GetFile(item));
            });
            const results: FileAttachment[] = [];
            let type = FileAttachmentTypeEnum.image.toString();
            if (question.input_type === QuestionTypes.file) type = FileAttachmentTypeEnum.file.toString();
            else if (question.input_type === QuestionTypes.camera) type = FileAttachmentTypeEnum.image.toString();
            Promise.all(promiseFile).then((resolve2) => {
                resolve2.map((res) => {
                    if (res && ws) {
                        const form = new FormData();
                        form.append('file', res);
                        form.append('alt', res.name ?? '');
                        form.append('filename', res.name);
                        form.append('name', res.name);
                        form.append('type', type);
                        form.append('workspace', ws.toString());
                        promiseUpload.push(upload<FileAttachment>(API.upload.slp(token), form, false));
                    }
                });
                Promise.all(promiseUpload).then((res1) => {
                    res1.map((res, index) => {
                        if (res.data) {
                            results.push(res.data);
                            const uploadedFile = fileNames[index];
                            if (uploadedFile) deleteFile(uploadedFile);
                        }
                    });
                    if (results.length) {
                        resolve(results);
                    } else resolve(undefined);
                });
            });
        }
    });
};

export const FileManager = {
    StoreFile,
    GetFile,
    UploadFile,
    RenderFile,
    deleteFile,
};
